import { adminState, getApi, http, adminGet, adminDelete, adminPost, adminPut } from './useAdminCore';
// ==================== Employers ====================
function getEmployers(onSuccess = null) {
    adminState.employersLoading = true;
    adminState.employersError = null;
    adminGet("/Employers", (result) => {
        adminState.employers = result;
        adminState.employersLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function getEmployerDetails(id, onSuccess = null) {
    adminGet("/Employers/" + id, (result) => {
        if (onSuccess)
            onSuccess(result);
    });
}
function getFreeLicenses(id, onSuccess = null) {
    adminGet("/Employers/" + id + "/FreeLicenses", (result) => {
        if (onSuccess)
            onSuccess(result);
    });
}
function createEmployer(employerData, onSuccess = null, onError = null) {
    adminPost('/Employers', employerData, (data) => {
        getEmployers();
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        const errorMsg = 'Failed to create employer';
        adminState.employersError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function updateEmployer(id, employerData, onSuccess = null, onError = null) {
    adminPut('/Employers/' + id, employerData, (data) => {
        getEmployers();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        const errorMsg = 'Failed to update employer';
        adminState.employersError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function uploadKeys(id, keys, onSuccess = null, onError = null) {
    const payload = { employerId: id, keys: keys };
    adminPost('/Employers/' + id + '/CreateEmployerGatewayKeysRequests', payload, onSuccess, (error) => {
        const errorMsg = 'Failed to upload keys';
        adminState.employersError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function removeKeys(id, keys = [], onSuccess = null, onError = null) {
    const payload = { employerId: id, keys: keys };
    adminPost('/Employers/' + id + '/DeleteEmployerGatewayKeysRequests', payload, onSuccess, (error) => {
        const errorMsg = 'Failed to remove keys';
        adminState.employersError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function deleteEmployer(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Employers/' + id)
        .then((response) => {
        getEmployers();
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch(() => {
        const errorMsg = 'Failed to delete employer';
        adminState.employersError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
// ==================== Employer Knowledge Base ====================
function uploadEmployerKnowledgeBase(employerId, fileData, onSuccess = null, onError = null) {
    adminPost(`/Employers/${employerId}/KnowledgeBase/Files/UploadRequests`, fileData, onSuccess, (error) => {
        const errorMsg = 'Failed to upload file';
        adminState.employersError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function getEmployerKnowledgeBaseFiles(employerId, onSuccess = null) {
    adminGet(getApi() + `/Employers/${employerId}/KnowledgeBase/Files`, onSuccess);
}
function deleteEmployerKnowledgeBaseFile(employerId, fileId, onSuccess = null) {
    adminDelete(getApi() + `/Employers/${employerId}/KnowledgeBase/Files/${fileId}`, onSuccess);
}
// ==================== Employer Member Get Member ====================
function getMemberGetMemberConfiguration(employerId, onSuccess = null) {
    adminGet(`/Employers/${employerId}/MemberGetMemberConfiguration`, onSuccess);
}
function saveMemberGetMemberConfiguration(employerId, config, onSuccess = null, onError = null) {
    adminPost(`/Employers/${employerId}/MemberGetMemberConfigurationRequests`, config, onSuccess, (error) => {
        const errorMsg = 'Failed to save Member Get Member configuration';
        adminState.employersError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
// ==================== Customers ====================
function getCustomers(onSuccess = null) {
    adminState.customersLoading = true;
    adminState.customersError = null;
    adminGet("/Customers", (result) => {
        adminState.customers = result;
        adminState.customersLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function getSelf(onSuccess = null) {
    adminGet("/Customers/00000000-0000-0000-0000-000000000000", (result) => {
        if (result && result.id) {
            adminState.selfId = result.id;
        }
        if (onSuccess)
            onSuccess(result);
    });
}
function getCustomerCreditTransactions(id, onSuccess = null) {
    adminGet("/Customers/" + id + "/Discounts/CustomerCreditTransactions", onSuccess);
}
function getCustomerPayments(id, onSuccess = null) {
    adminGet("/Customers/" + id + "/Payments", onSuccess);
}
function addCustomerCredit(customerId, amount, onSuccess = null, onError = null) {
    const payload = { customerID: customerId, amount: amount };
    adminPost('/Discounts/CustomerCreditTransactions', payload, onSuccess, (error) => {
        if (onError)
            onError('Failed to add credit');
    });
}
function postFactCard(customerId, facts, onSuccess = null, onError = null) {
    const payload = [];
    for (const key in facts) {
        payload.push({ name: key, value: facts[key] });
    }
    adminPost('/Customers/' + customerId + '/FactCard', payload, onSuccess, (error) => {
        if (onError)
            onError('Failed to post fact card');
    });
}
function generateMoves(customerId, onSuccess = null, onError = null) {
    adminPost('/Moves/GenerationRequests?customerId=' + customerId, null, onSuccess, (error) => {
        if (onError)
            onError('Failed to generate moves');
    });
}
function getCustomerDetails(id, getFacts = false, onSuccess = null) {
    adminGet("/Customers/" + id + "?getEmployer=true&getFacts=" + getFacts, onSuccess);
}
function getCustomerPolicies(id, onSuccess = null) {
    adminGet("/Customers/" + id + "/Policies", onSuccess);
}
function getCustomerInvestments(id, onSuccess = null) {
    adminGet("/Customers/" + id + "/InvestmentHubAccounts", onSuccess);
}
function getCustomerMoves(id, onSuccess = null) {
    adminGet("/Customers/" + id + "/Moves", onSuccess);
}
function getCustomerCompletedMoves(id, onSuccess = null) {
    adminGet("/Customers/" + id + "/Moves?filterByActioned=true", onSuccess);
}
function linkEmployerToCustomer(customerId, employerId, onSuccess = null, onError = null) {
    if (employerId) {
        adminPost('/Customers/' + customerId + '/LinkToEmployerRequests?employerId=' + employerId, null, (data) => {
            getCustomers();
            if (onSuccess)
                onSuccess(data);
        }, (error) => {
            const errorMsg = 'Failed to link employer';
            adminState.customersError = errorMsg;
            if (onError)
                onError(errorMsg);
        });
    }
    else {
        adminPost('/Customers/' + customerId + '/UnlinkFromEmployerRequests', null, (data) => {
            getCustomers();
            if (onSuccess)
                onSuccess(data);
        }, (error) => {
            const errorMsg = 'Failed to unlink employer';
            adminState.customersError = errorMsg;
            if (onError)
                onError(errorMsg);
        });
    }
}
// ==================== Documents ====================
function getDocuments(onSuccess = null) {
    adminGet("/Documents", onSuccess);
}
function retryDocument(id, flatObject = null, onSuccess = null, onError = null) {
    const url = flatObject
        ? '/Documents/' + id + '/RetryRequests?flatObject=' + btoa(flatObject)
        : '/Documents/' + id + '/RetryRequests';
    adminPost(url, null, onSuccess, (error) => {
        if (onError)
            onError('Failed to retry document processing');
    });
}
// ==================== Customer Notes ====================
function getCustomerNotes(customerId, onSuccess = null) {
    adminGet("/Customers/" + customerId + "/Notes", onSuccess);
}
function createCustomerNote(customerId, noteData, onSuccess = null, onError = null) {
    adminPost('/Customers/' + customerId + '/Notes', noteData, onSuccess, (error) => {
        if (onError)
            onError('Failed to create note');
    });
}
function updateCustomerNote(customerId, updateData, onSuccess = null, onError = null) {
    adminPost('/Customers/' + customerId + '/UpdateRequests', updateData, onSuccess, (error) => {
        if (onError)
            onError('Failed to update note');
    });
}
// ==================== Moves (PSMs) ====================
function getMoves(onSuccess = null) {
    adminGet("/Moves", onSuccess);
}
function createMove(moveData, onSuccess = null, onError = null) {
    adminPost('/Moves', moveData, onSuccess, () => {
        if (onError)
            onError('Failed to create PSM');
    });
}
function updateMove(id, moveData, onSuccess = null, onError = null) {
    adminPut('/Moves/' + id, moveData, onSuccess, () => {
        if (onError)
            onError('Failed to save PSM');
    });
}
function deleteMove(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Moves/' + id)
        .then(() => {
        if (onSuccess)
            onSuccess();
    })
        .catch((error) => {
        console.error('Error deleting move:', error);
        if (onError)
            onError('Sorry, that PSM cannot be deleted. This may mean moves have already been generated against it — we cannot rewrite history.');
    });
}
function getMoveCriteria(onSuccess = null) {
    adminGet("/Criteria", onSuccess);
}
export { 
// Employers
getEmployers, getEmployerDetails, getFreeLicenses, createEmployer, updateEmployer, uploadKeys, removeKeys, deleteEmployer, uploadEmployerKnowledgeBase, getEmployerKnowledgeBaseFiles, deleteEmployerKnowledgeBaseFile, getMemberGetMemberConfiguration, saveMemberGetMemberConfiguration, 
// Customers
getCustomers, getSelf, getCustomerCreditTransactions, getCustomerPayments, addCustomerCredit, postFactCard, generateMoves, getCustomerDetails, getCustomerPolicies, getCustomerInvestments, getCustomerMoves, getCustomerCompletedMoves, linkEmployerToCustomer, 
// Documents
getDocuments, retryDocument, 
// Customer Notes
getCustomerNotes, createCustomerNote, updateCustomerNote, 
// Moves (PSMs)
getMoves, createMove, updateMove, deleteMove, getMoveCriteria, };
